module.exports = __webpack_public_path__ + "img/img_bg.70ec8aea.png";